import {Tax} from '../../../../types/TransactionDetail';

type ReceiptData = {
  fpSubTotal: string;
  taxes?: Tax[];
};

export function calculateFpSubtotalWithTaxes({
  taxes,
  fpSubTotal,
}: ReceiptData): number {
  const subtotal = parseFloat(fpSubTotal);

  const totalTax = (taxes ?? []).reduce((sum, tax) => {
    const taxAmount = parseFloat(tax.TaxAmount);
    return sum + (isNaN(taxAmount) ? 0 : taxAmount);
  }, 0);

  return parseFloat((subtotal + totalTax).toFixed(2));
}
